var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIInkaIcon21 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 50,
    viewBox: "0 0 8 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0080c8",
    fillRule: "evenodd",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 23,
    y: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 5,
    r: 4
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIInkaIcon21, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i-inka-icon_2-1.d6163844.svg";
export { ForwardRef as ReactComponent };